import React from 'react';
import PropTypes from 'prop-types';
import { CloseIcon } from '../../assets/icons';

const FilterBadge = ({ filterKey, filterValue, filterLabel, onRemove }) => {
  // Now filterValue is always a primitive value to display directly
  
  // Handle the click on the remove button
  const handleRemove = () => {
    onRemove(filterKey);
  };
  
  // Make sure we're only showing strings or numbers, not objects
  const displayValue = typeof filterValue === 'object' && filterValue !== null 
    ? (filterValue.label || JSON.stringify(filterValue)) 
    : String(filterValue);
  
  return (
    <div className="filter-badge">
      <span className="filter-badge-text">{displayValue}</span>
      <button 
        className="filter-badge-close" 
        onClick={handleRemove}
        aria-label={`Remove ${filterLabel} filter`}
      >
        <CloseIcon color='#18964e' />
      </button>
    </div>
  );
};

FilterBadge.propTypes = {
  filterKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]).isRequired,
  filterValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object // Allow object but we'll handle it in the component
  ]).isRequired,
  filterLabel: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired
};

export default FilterBadge;
